/* upsell-total.js — shows "Total with add-ons" under the product_upsell block and
   mirrors the total on the Add to cart button. Reads the main variant price from the
   variant-change event and the selected upsells' data-price (cents). No cart calls. */
(function () {
  if (customElements.get('upsell-total')) return;

  class UpsellTotal extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.basePrice = parseFloat(this.dataset.basePrice) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.labelEl = this.querySelector('.upsell-total__label');
      this.priceEl = this.querySelector('.upsell-total__price');
      this.section = this.closest('.shopify-section') || document;
      this.atc = this.section.querySelector('#ProductSubmitButton-' + this.sectionId) ||
                 this.section.querySelector('product-form button[type="submit"]');
      if (this.atc) {
        const label = this.atc.querySelector('.button__label, .main-atc__label') || this.atc.querySelector('span') || this.atc;
        this.atcLabelEl = label;
        this.atcBaseText = label.textContent.trim();
      }
      this.upsells = () => Array.from(this.section.querySelectorAll('product-info-upsell'));

      // Any click inside an upsell card may toggle it; recompute after the theme's own handler ran.
      this.section.addEventListener('click', (e) => {
        if (e.target.closest('product-info-upsell')) setTimeout(() => this.render(), 0);
      });
      this.section.addEventListener('change', (e) => {
        if (e.target.closest('product-info-upsell')) setTimeout(() => this.render(), 0);
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
          const v = ev && ev.data && ev.data.variant;
          if (v && ev.data.sectionId === this.sectionId && typeof v.price === 'number') {
            this.basePrice = v.price;
            // the ATC button is re-rendered on variant change; re-grab it
            setTimeout(() => { this.atc = null; this.grabAtc(); this.render(); }, 0);
          }
        });
      }
      this.render();
    }
    disconnectedCallback() { if (this.unsubscribe) this.unsubscribe(); }
    grabAtc() {
      this.atc = this.section.querySelector('#ProductSubmitButton-' + this.sectionId) ||
                 this.section.querySelector('product-form button[type="submit"]');
      if (this.atc) {
        this.atcLabelEl = this.atc.querySelector('.button__label, .main-atc__label') || this.atc.querySelector('span') || this.atc;
        const t = this.atcLabelEl.textContent.trim();
        if (t && !/[\d]/.test(t)) this.atcBaseText = t; // keep the plain label (no price)
      }
    }
    fmt(cents) {
      if (typeof formatMoney === 'function') return formatMoney(Math.round(cents), this.moneyFormat);
      return '$' + (cents / 100).toFixed(2);
    }
    render() {
      const sel = this.upsells().filter((u) => u.dataset.selected === 'true');
      const extra = sel.reduce((s, u) => s + (parseFloat(u.dataset.price) || 0), 0);
      const total = this.basePrice + extra;
      if (sel.length === 0) {
        this.classList.add('hidden');
        if (this.atcLabelEl && this.atcBaseText) this.atcLabelEl.textContent = this.atcBaseText;
        return;
      }
      this.classList.remove('hidden');
      const label = sel.length === 1 ? this.dataset.labelOne : (this.dataset.labelMany || '').replace('[n]', sel.length);
      this.labelEl.textContent = label;
      this.priceEl.textContent = this.fmt(total);
      if (this.atcLabelEl && this.atcBaseText && !this.atc.hasAttribute('disabled')) {
        this.atcLabelEl.textContent = this.atcBaseText + ' — ' + this.fmt(total);
      }
    }
  }
  customElements.define('upsell-total', UpsellTotal);

  /* When add-ons are selected the theme submits items[] for drone + add-ons, but the plain
     `id`/`quantity` fields were only stripped when a quantity-breaks block existed — without it
     Shopify honoured `id` and dropped the add-ons. Strip them here (capture phase, before the
     theme's submit handler builds FormData; re-enabled right after). */
  document.addEventListener('submit', function (e) {
    const form = e.target;
    const pf = form.closest && form.closest('product-form.main-product-form');
    if (!pf) return;
    pf.ref = false; // leftover licence kill-switch flag in main.js that blocks items[] submission
    const section = pf.dataset.section;
    const selected = document.querySelectorAll('.product-info-upsell-' + section + '[data-selected="true"]');
    if (!selected.length) return;
    const fields = Array.from(form.elements).filter(function (el) {
      return el.name === 'id' || el.name === 'quantity' || /^options\[/.test(el.name || '');
    });
    fields.forEach(function (el) { el.disabled = true; });
    setTimeout(function () { fields.forEach(function (el) { el.disabled = false; }); }, 0);
  }, true);
})();
